// Mock podaci za demo mode

// Mock tenant (radnja)
export const mockTenant = {
  _id: 'demo-tenant-1',
  name: 'Demo Salon',
  subdomain: 'demo-salon',
  email: 'demo@salon.com',
  phone: '+381 11 123 4567',
  address: {
    street: 'Knez Mihailova',
    city: 'Beograd',
    number: '15'
  },
  logoUrl: '',
  description: 'Demo radnja za prikaz funkcionalnosti sistema',
  isActive: true,
  numberOfEmployees: 2,
  workingHours: {
    monday: { isOpen: true, open: '09:00', close: '18:00' },
    tuesday: { isOpen: true, open: '09:00', close: '18:00' },
    wednesday: { isOpen: true, open: '09:00', close: '18:00' },
    thursday: { isOpen: true, open: '09:00', close: '18:00' },
    friday: { isOpen: true, open: '09:00', close: '18:00' },
    saturday: { isOpen: true, open: '09:00', close: '15:00' },
    sunday: { isOpen: false, open: '09:00', close: '17:00' }
  },
  settings: {
    allowOnlineBooking: true,
    requireConfirmation: false,
    enableQuickAppointment: true,
    defaultAppointmentMode: 'quick',
    hasShifts: false,
    autoAssignEmployee: true,
    externalUserRegistration: true,
    approvalOfExternalUserRegistration: false,
    partiallyRequireConfirmation: false
  }
};

// Mock kategorije usluga
export const mockCategories = [
  {
    _id: 'demo-cat-1',
    name: 'Frizerske usluge',
    description: 'Sve frizerske usluge',
    tenantId: 'demo-tenant-1',
    isActive: true
  },
  {
    _id: 'demo-cat-2',
    name: 'Nokti',
    description: 'Manikir i pedikir',
    tenantId: 'demo-tenant-1',
    isActive: true
  }
];

// Mock usluge
export const mockServices = [
  {
    _id: 'demo-service-1',
    name: 'Muško šišanje',
    description: 'Profesionalno muško šišanje',
    duration: 30,
    price: { amount: 800 },
    categoryId: { _id: 'demo-cat-1', name: 'Frizerske usluge' },
    tenantId: { _id: 'demo-tenant-1', name: 'Demo Salon' },
    isActive: true
  },
  {
    _id: 'demo-service-2',
    name: 'Žensko šišanje',
    description: 'Profesionalno žensko šišanje',
    duration: 60,
    price: { amount: 1500 },
    categoryId: { _id: 'demo-cat-1', name: 'Frizerske usluge' },
    tenantId: { _id: 'demo-tenant-1', name: 'Demo Salon' },
    isActive: true
  },
  {
    _id: 'demo-service-3',
    name: 'Farbanje',
    description: 'Farbanje kose',
    duration: 120,
    price: { amount: 3000 },
    categoryId: { _id: 'demo-cat-1', name: 'Frizerske usluge' },
    tenantId: { _id: 'demo-tenant-1', name: 'Demo Salon' },
    isActive: true
  },
  {
    _id: 'demo-service-4',
    name: 'Manikir',
    description: 'Profesionalni manikir',
    duration: 45,
    price: { amount: 1200 },
    categoryId: { _id: 'demo-cat-2', name: 'Nokti' },
    tenantId: { _id: 'demo-tenant-1', name: 'Demo Salon' },
    isActive: true
  }
];

// Mock zaposleni
export const mockEmployees = [
  {
    _id: 'demo-employee-1',
    firstName: 'Marko',
    lastName: 'Petrović',
    email: 'marko@demo.com',
    phone: '+381 11 111 1111',
    userType: 'employee',
    tenantId: 'demo-tenant-1',
    isActive: true
  },
  {
    _id: 'demo-employee-2',
    firstName: 'Ana',
    lastName: 'Jovanović',
    email: 'ana@demo.com',
    phone: '+381 11 222 2222',
    userType: 'employee',
    tenantId: 'demo-tenant-1',
    isActive: true
  }
];

// Mock korisnici (customers)
export const mockCustomers = [
  {
    _id: 'demo-user-1',
    firstName: 'Demo',
    lastName: 'Korisnik',
    email: 'demo@zakazuj.com',
    phone: '+381 11 333 3333',
    userType: 'customer',
    tenantId: 'demo-tenant-1',
    isActive: true
  },
  {
    _id: 'demo-customer-2',
    firstName: 'Jovana',
    lastName: 'Demo',
    email: 'jovana@demo.com',
    phone: '+381 11 444 4444',
    userType: 'customer',
    tenantId: 'demo-tenant-1',
    isActive: true
  },
  {
    _id: 'demo-customer-3',
    firstName: 'Milan',
    lastName: 'Demo',
    email: 'milan@demo.com',
    phone: '+381 11 555 5555',
    userType: 'customer',
    tenantId: 'demo-tenant-1',
    isActive: true
  }
];

// Mock dostupni dani (sledećih 30 dana)
const getAvailableDates = () => {
  const dates = [];
  const today = new Date();
  for (let i = 1; i <= 30; i++) {
    const date = new Date(today);
    date.setDate(today.getDate() + i);
    const dayOfWeek = date.getDay();
    // Ne dodaj nedelje (0) i subote (6) ako su zatvoreni
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      dates.push({
        date: `${year}-${month}-${day}`,
        availableSlots: ['09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00']
      });
    }
  }
  return dates;
};

export const mockAvailableDays = {
  data: {
    availableDates: getAvailableDates(),
    unavailableDates: []
  }
};

// Mock dostupni slotovi za određeni dan
export const getMockAvailableSlots = (date) => {
  return {
    data: {
      availableSlots: ['09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00']
    }
  };
};

// Mock termini (za kalendar/pregled)
// Generiši termine za različite datume u budućnosti
const getMockAppointments = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  // Termin za danas (u prošlosti - već završen)
  const todayPast = new Date(today);
  todayPast.setHours(9, 0, 0, 0); // 09:00
  
  // Termin u prošlosti (juče)
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  yesterday.setHours(14, 30, 0, 0); // 14:30 juče
  
  // Termin u prošlosti (pre 3 dana)
  const threeDaysAgo = new Date(today);
  threeDaysAgo.setDate(today.getDate() - 3);
  threeDaysAgo.setHours(11, 0, 0, 0); // 11:00 pre 3 dana
  
  // Termin za danas (trenutno u toku ili uskoro)
  const todayNow = new Date(today);
  const currentHour = new Date().getHours();
  const nextHour = currentHour < 17 ? currentHour + 1 : 17;
  todayNow.setHours(nextHour, 0, 0, 0);
  
  // Termin za danas (2 sata ispred trenutnog - za "sledeći termin")
  const todayNext = new Date(today);
  const currentHourForNext = new Date().getHours();
  const nextHourForNext = currentHourForNext + 2;
  todayNext.setHours(nextHourForNext < 18 ? nextHourForNext : 18, 0, 0, 0);
  
  // Termin za danas (kasnije danas)
  const todayLater = new Date(today);
  todayLater.setHours(15, 0, 0, 0); // 15:00
  
  // Termin za sutra
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);
  
  // Termin za prekosutra
  const dayAfterTomorrow = new Date(today);
  dayAfterTomorrow.setDate(today.getDate() + 2);
  
  // Termin za 3 dana
  const in3Days = new Date(today);
  in3Days.setDate(today.getDate() + 3);
  
  // Termin za 5 dana
  const in5Days = new Date(today);
  in5Days.setDate(today.getDate() + 5);
  
  return [
    // Termini u prošlosti za demo-user-1
    {
      _id: 'demo-appointment-past-1',
      appointmentDate: threeDaysAgo.toISOString(),
      selectedTime: '11:00',
      duration: 45,
      totalPrice: 1200,
      status: 'confirmed',
      serviceIds: [{ _id: 'demo-service-4', name: 'Manikir' }],
      customerId: { _id: 'demo-user-1', firstName: 'Demo', lastName: 'Korisnik' },
      employeeId: { _id: 'demo-employee-2', firstName: 'Ana', lastName: 'Jovanović' },
      tenantId: { _id: 'demo-tenant-1', name: 'Demo Salon' },
      isQuickAppointment: false
    },
    {
      _id: 'demo-appointment-past-2',
      appointmentDate: yesterday.toISOString(),
      selectedTime: '14:30',
      duration: 60,
      totalPrice: 1500,
      status: 'confirmed',
      serviceIds: [{ _id: 'demo-service-2', name: 'Žensko šišanje' }],
      customerId: { _id: 'demo-user-1', firstName: 'Demo', lastName: 'Korisnik' },
      employeeId: { _id: 'demo-employee-1', firstName: 'Marko', lastName: 'Petrović' },
      tenantId: { _id: 'demo-tenant-1', name: 'Demo Salon' },
      isQuickAppointment: false
    },
    // Termini za danas
    {
      _id: 'demo-appointment-today-1',
      appointmentDate: todayPast.toISOString(),
      selectedTime: '09:00',
      duration: 30,
      totalPrice: 800,
      status: 'confirmed',
      serviceIds: [{ _id: 'demo-service-1', name: 'Muško šišanje' }],
      customerId: { _id: 'demo-user-1', firstName: 'Demo', lastName: 'Korisnik' },
      employeeId: { _id: 'demo-employee-1', firstName: 'Marko', lastName: 'Petrović' },
      tenantId: { _id: 'demo-tenant-1', name: 'Demo Salon' },
      isQuickAppointment: false
    },
    {
      _id: 'demo-appointment-today-2',
      appointmentDate: todayNow.toISOString(),
      selectedTime: `${String(nextHour).padStart(2, '0')}:00`,
      duration: 60,
      totalPrice: 1500,
      status: 'confirmed',
      serviceIds: [{ _id: 'demo-service-2', name: 'Žensko šišanje' }],
      customerId: { _id: 'demo-customer-2', firstName: 'Jovana', lastName: 'Demo' },
      employeeId: { _id: 'demo-employee-2', firstName: 'Ana', lastName: 'Jovanović' },
      tenantId: { _id: 'demo-tenant-1', name: 'Demo Salon' },
      isQuickAppointment: false
    },
    {
      _id: 'demo-appointment-today-next',
      appointmentDate: todayNext.toISOString(),
      selectedTime: `${String(nextHourForNext < 18 ? nextHourForNext : 18).padStart(2, '0')}:00`,
      duration: 30,
      totalPrice: 800,
      status: 'confirmed',
      serviceIds: [{ _id: 'demo-service-1', name: 'Muško šišanje' }],
      customerId: { _id: 'demo-user-1', firstName: 'Demo', lastName: 'Korisnik' },
      employeeId: { _id: 'demo-employee-1', firstName: 'Marko', lastName: 'Petrović' },
      tenantId: { _id: 'demo-tenant-1', name: 'Demo Salon' },
      isQuickAppointment: false
    },
    {
      _id: 'demo-appointment-today-3',
      appointmentDate: todayLater.toISOString(),
      selectedTime: '15:00',
      duration: 45,
      totalPrice: 1200,
      status: 'confirmed',
      serviceIds: [{ _id: 'demo-service-4', name: 'Manikir' }],
      customerId: { _id: 'demo-customer-3', firstName: 'Milan', lastName: 'Demo' },
      employeeId: { _id: 'demo-employee-1', firstName: 'Marko', lastName: 'Petrović' },
      tenantId: { _id: 'demo-tenant-1', name: 'Demo Salon' },
      isQuickAppointment: false
    },
    // Termini za budućnost
    {
      _id: 'demo-appointment-1',
      appointmentDate: tomorrow.toISOString(),
      selectedTime: '10:00',
      duration: 30,
      totalPrice: 800,
      status: 'confirmed',
      serviceIds: [{ _id: 'demo-service-1', name: 'Muško šišanje' }],
      customerId: { _id: 'demo-user-1', firstName: 'Demo', lastName: 'Korisnik' },
      employeeId: { _id: 'demo-employee-1', firstName: 'Marko', lastName: 'Petrović' },
      tenantId: { _id: 'demo-tenant-1', name: 'Demo Salon' },
      isQuickAppointment: false
    },
    {
      _id: 'demo-appointment-2',
      appointmentDate: dayAfterTomorrow.toISOString(),
      selectedTime: '14:00',
      duration: 60,
      totalPrice: 1500,
      status: 'confirmed',
      serviceIds: [{ _id: 'demo-service-2', name: 'Žensko šišanje' }],
      customerId: { _id: 'demo-customer-2', firstName: 'Jovana', lastName: 'Demo' },
      employeeId: { _id: 'demo-employee-2', firstName: 'Ana', lastName: 'Jovanović' },
      tenantId: { _id: 'demo-tenant-1', name: 'Demo Salon' },
      isQuickAppointment: false
    },
    {
      _id: 'demo-appointment-3',
      appointmentDate: in3Days.toISOString(),
      selectedTime: '11:00',
      duration: 45,
      totalPrice: 1200,
      status: 'confirmed',
      serviceIds: [{ _id: 'demo-service-4', name: 'Manikir' }],
      customerId: { _id: 'demo-customer-3', firstName: 'Milan', lastName: 'Demo' },
      employeeId: { _id: 'demo-employee-1', firstName: 'Marko', lastName: 'Petrović' },
      tenantId: { _id: 'demo-tenant-1', name: 'Demo Salon' },
      isQuickAppointment: false
    },
    {
      _id: 'demo-appointment-4',
      appointmentDate: in5Days.toISOString(),
      selectedTime: '15:00',
      duration: 120,
      totalPrice: 3000,
      status: 'confirmed',
      serviceIds: [{ _id: 'demo-service-3', name: 'Farbanje' }],
      customerId: { _id: 'demo-user-1', firstName: 'Demo', lastName: 'Korisnik' },
      employeeId: { _id: 'demo-employee-2', firstName: 'Ana', lastName: 'Jovanović' },
      tenantId: { _id: 'demo-tenant-1', name: 'Demo Salon' },
      isQuickAppointment: false
    }
  ];
};

export const mockAppointments = getMockAppointments();

// Mock user za demo mode (customer)
export const mockUser = {
  _id: 'demo-user-1',
  firstName: 'Demo',
  lastName: 'Korisnik',
  email: 'demo@zakazuj.com',
  userType: 'customer',
  tenantId: {
    _id: 'demo-tenant-1',
    name: 'Demo Salon'
  },
  tenantConnections: [
    {
      tenantId: {
        _id: 'demo-tenant-1',
        name: 'Demo Salon',
        subdomain: 'demo-salon'
      },
      userType: 'customer',
      approved: true
    }
  ]
};

// Mock user za demo mode (tenant_admin)
export const mockTenantAdminUser = {
  _id: 'demo-admin-1',
  firstName: 'Demo',
  lastName: 'Vlasnik',
  email: 'demo-admin@zakazuj.com',
  userType: 'tenant_admin',
  tenantId: {
    _id: 'demo-tenant-1',
    name: 'Demo Salon'
  },
  tenantConnections: [
    {
      tenantId: {
        _id: 'demo-tenant-1',
        name: 'Demo Salon',
        subdomain: 'demo-salon'
      },
      userType: 'tenant_admin',
      approved: true
    }
  ]
};

// Mock response wrapper funkcije
export const createMockResponse = (data) => {
  return Promise.resolve(data);
};

export const createMockError = (message, status = 400) => {
  const error = new Error(message);
  error.response = { status, data: { error: message } };
  return Promise.reject(error);
};
